import { MiscellaneousReducerState } from './miscellaneousReducer.types';

export const MISCELLANEOUS_REDUCER_INITIAL_STATE = Object.freeze<MiscellaneousReducerState>({
    isWaitingForAuthStateChange: true,
    firebaseUser: null,

    isHeaderTransparent: false,
    isPersistentDrawerOpened: false,
});
